import { render, staticRenderFns } from "./ot-project-users-index.vue?vue&type=template&id=197aac88&scoped=true&"
import script from "./ot-project-users-index.vue?vue&type=script&lang=ts&"
export * from "./ot-project-users-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-users-index.vue?vue&type=style&index=0&id=197aac88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197aac88",
  null
  
)

export default component.exports